import { Injectable, inject } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@ngneat/transloco';

@Injectable()
export class ArabicPaginatorIntl extends MatPaginatorIntl {
    private _translocoService = inject(TranslocoService);

    constructor() {
        super();
        // Initialize with current active language
        this.updateLabels(this._translocoService.getActiveLang());

        this._translocoService.langChanges$.subscribe((language) => {
            this.updateLabels(language);
        });
    }
    selectedLang = '';
    updateLabels(language: string): void {
        if (language === 'ar') {
            this.selectedLang = 'ar';
            this.itemsPerPageLabel = 'عناصر في الصفحة:';
            this.nextPageLabel = 'الصفحة التالية';
            this.previousPageLabel = 'الصفحة السابقة';
            this.firstPageLabel = 'الصفحة الأولى';
            this.lastPageLabel = 'الصفحة الأخيرة';
        } else {
            this.selectedLang = 'en';
            this.itemsPerPageLabel = 'Items per page:';
            this.nextPageLabel = 'Next page';
            this.previousPageLabel = 'Previous page';
            this.firstPageLabel = 'First page';
            this.lastPageLabel = 'Last page';
        }
        this.changes.next(); // This notifies the paginator to refresh labels
    }

    getRangeLabel = (page, pageSize, length) => {
        if (this.selectedLang === 'ar') {
            if (length === 0 || pageSize === 0) {
                return `0 من ${length}`;
            }
            const startIndex = page * pageSize;
            const endIndex =
                startIndex < length
                    ? Math.min(startIndex + pageSize, length)
                    : startIndex + pageSize;
            return `${startIndex + 1} - ${endIndex} من ${length}`;
        } else {
            if (length === 0 || pageSize === 0) {
                return `0 of ${length}`;
            }
            const startIndex = page * pageSize;
            const endIndex =
                startIndex < length
                    ? Math.min(startIndex + pageSize, length)
                    : startIndex + pageSize;
            return `${startIndex + 1} - ${endIndex} of ${length}`;
        }
    };
}
